export function conjoinItems(items, options) {
  if (options === void 0) {
    options = {};
  }
  var _a = options.separator,
    separator = _a === void 0 ? ", " : _a,
    _b = options.finalConjunction,
    finalConjunction = _b === void 0 ? "and" : _b;
  if (items.length === 0) return "";
  if (items.length === 1) return items[0];
  if (items.length === 2) return "".concat(items[0], " ").concat(finalConjunction, " ").concat(items[1]);
  var allButLast = items.slice(0, -1).join(separator);
  var last = items[items.length - 1];
  return "".concat(allButLast, " ").concat(finalConjunction, " ").concat(last);
}
// Example usage:
// const items = ["apples", "bananas", "cherries", "dates"];
// const result = conjoinItems(items);
// console.log(result); // "apples, bananas, cherries and dates"